<template>
  <div class="visitor-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>访客姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入访客姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>受访住户</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入受访住户" v-model="table.search.residentName"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>访客事由</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入访客事由" v-model="table.search.event"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="status" slot-scope="text, data">{{visitorStatusText(data.is_visit)}}</template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="visitorInfo(data)">查看</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <visitor-details :id="drawer.id"></visitor-details>
    </a-drawer>
  </div>
</template>

<script>
  import {
    visitorStatusText
  } from '@/io/dict.js';
  import VisitorService from '@/io/visitor.js';
  import VisitorDetails from '@/views/community/VisitorDetails.vue';

  export default {
    name: 'VisitorManage',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        visitorStatusText,
        table: {
          loading: false,
          search: {
            name: null,
            residentName: null,
            event: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '访客姓名',
              dataIndex: 'visitor_name'
            },
            {
              title: '访客事由',
              dataIndex: 'visit_purpose'
            },
            {
              title: '访客人数',
              dataIndex: 'visitor_number'
            },
            {
              title: '受访住户',
              dataIndex: 'resident_name'
            },
            {
              title: '受访房屋',
              dataIndex: 'resident_address'
            },
            {
              title: '有效截止时间',
              dataIndex: 'visit_time'
            },
            {
              title: '申请时间',
              dataIndex: 'created_at'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'status' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        drawer: {
          id: null,
          title: '访客详情',
          show: false,
        }
      }
    },
    components: {
      VisitorDetails,
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    activated() {
      if (this.communityId) {
        this.initData();
      }
    },
    methods: {
      visitorInfo(data) {
        this.drawer.id = data.id;
        this.drawer.show = true; 
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          residentName: null,
          event: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        VisitorService.listPage(
          this.communityId,
          this.table.search.name,
          this.table.search.residentName,
          this.table.search.event,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.visit_time = val.visit_time.split(' ')[0];
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>